var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.32 0H3.786A3.787 3.787 0 000 3.787V24.32a3.787 3.787 0 003.787 3.788h10.127l.017-10.044h-2.61a.616.616 0 01-.615-.613l-.013-3.238a.616.616 0 01.616-.618h2.605v-3.128c0-3.63 2.217-5.607 5.455-5.607h2.658c.34 0 .616.275.616.615v2.73c0 .34-.276.616-.616.616h-1.63c-1.762 0-2.103.838-2.103 2.066v2.708h3.87c.369 0 .655.322.611.688l-.383 3.238a.616.616 0 01-.612.543h-3.469l-.017 10.044h6.025a3.787 3.787 0 003.788-3.787V3.787A3.788 3.788 0 0024.319 0z",
    fill: "url(#facebook_svg__paint0_linear_8793_23534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.32 0H3.786A3.787 3.787 0 000 3.787V24.32a3.787 3.787 0 003.787 3.788h10.127l.017-10.044h-2.61a.616.616 0 01-.615-.613l-.013-3.238a.616.616 0 01.616-.618h2.605v-3.128c0-3.63 2.217-5.607 5.455-5.607h2.658c.34 0 .616.275.616.615v2.73c0 .34-.276.616-.616.616h-1.63c-1.762 0-2.103.838-2.103 2.066v2.708h3.87c.369 0 .655.322.611.688l-.383 3.238a.616.616 0 01-.612.543h-3.469l-.017 10.044h6.025a3.787 3.787 0 003.788-3.787V3.787A3.788 3.788 0 0024.319 0z",
    fill: "url(#facebook_svg__paint1_linear_8793_23534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__paint0_linear_8793_23534",
    x1: 28.668,
    y1: 0.258,
    x2: 0.264,
    y2: 28.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__paint1_linear_8793_23534",
    x1: 28.044,
    y1: 0.062,
    x2: 0.062,
    y2: 28.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })))));
}

export default __webpack_public_path__ + "./fonts/facebook.1f5108d6293516c8f08e742ad7117960.svg";
export { SvgFacebook as ReactComponent };